import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * Generates a QR code data URL for the given URL.
 *
 * This hook allows the pdf templates to get the QR image before the PDF starts rendering.
 * The web templates use this hook within the QRCallToActionWeb component.
 *
 * @param url
 * @returns {{qr: unknown, error: unknown}}
 */
export function useEFlyerQRCode(url) {
  const [qr, setQr] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const options = {
      size: 96,
      bgColor: '#FFFFFF',
      fgColor: '#000000',
      level: 'L'
    };

    async function generateQR() {
      if (!url) {
        setQr(null);
        setError(null);
        return;
      }
      try {
        const dataUrl = await QRCode.toDataURL(url, options);
        if (!cancelled) {
          setQr(dataUrl);
          setError(null);
        }
      } catch (e) {
        if (!cancelled) {
          console.error(e);
          setError(e);
          setQr(null);
        }
      }
    }

    generateQR();
    return () => {
      cancelled = true;
    };
  }, [url]);

  return { qr, error };
}
